
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(21584|57296)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
